import React, { FunctionComponent, SVGProps } from 'react'

export const IconUser: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#FCFCFC"
    {...props}
  >
    <path
      d="M17.4154 19.251V17.4176C17.4154 16.4452 17.0291 15.5126 16.3414 14.8249C15.6538 14.1373 14.7212 13.751 13.7487 13.751H8.2487C7.27624 13.751 6.34361 14.1373 5.65597 14.8249C4.96834 15.5126 4.58203 16.4452 4.58203 17.4176V19.251"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9987 10.0843C13.0237 10.0843 14.6654 8.44269 14.6654 6.41764C14.6654 4.3926 13.0237 2.75098 10.9987 2.75098C8.97365 2.75098 7.33203 4.3926 7.33203 6.41764C7.33203 8.44269 8.97365 10.0843 10.9987 10.0843Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
